import { render } from "./choice.vue?vue&type=template&id=e5ecad3a&scoped=true"
const script = {}

import "./choice.vue?vue&type=style&index=0&id=e5ecad3a&scoped=true&lang=css"

import exportComponent from "/var/www/html/koboeat/test/customer_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5ecad3a"]])

export default __exports__